import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { APIErrorType } from '../../api';
import { ExamResultType, fetchExamResults } from '../../api/exam-result';

export type useExamResultsReturnType = UseQueryResult<ExamResultType[]>;

export function useExamResults(
  examId: number | undefined,
  options: Omit<
    UseQueryOptions<
      ExamResultType[],
      APIErrorType,
      ExamResultType[],
      ReturnType<typeof getExamResultsQueryKey>
    >,
    'queryKey | queryFn'
  > = {}
): useExamResultsReturnType {
  if (!examId) throw Error('ExamId must be defined');
  return useQuery<
    ExamResultType[],
    APIErrorType,
    ExamResultType[],
    ReturnType<typeof getExamResultsQueryKey>
  >(getExamResultsQueryKey(examId), fetchExamResults, {
    staleTime: 30 * 1000,
    retry: false,
    ...options
  });
}

export const getExamResultsQueryKey: (examId: number) => [string, { examId: number }] = examId => [
  'exam-results',
  { examId }
];
